import styled from "styled-components";
import { keyframes } from "styled-components";

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const CarouselContainer = styled.div`
  width: 100vw;
  margin-left: -160px;
  margin-right: -160px;
  position: relative;
  overflow: hidden;

  @media (max-width: 960px) {
    margin-left: -40px;
    margin-right: -40px;
  }

  @media (max-width: 768px) {
    margin-left: -20px;
    margin-right: -20px;
  }
`;

export const CarouselWrapper = styled.div`
  width: 100%;
  position: relative;

  .right {
    right: 40px;
  }
  .left {
    left: 40px;
  }

  @media (max-width: 768px) {
    .right {
      right: 20px;
    }
    .left {
      left: 20px;
    }
  }
`;

export const CarouselSlide = styled.div`
  position: relative;
  width: 100%;
  height: 600px;
  animation: ${fadeIn} 0.5s ease-in-out;

  @media (max-width: 960px) {
    height: 450px;
  }

  @media (max-width: 768px) {
    height: 400px;
  }
`;

export const CarouselImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;

export const CarouselOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    to top,
    rgba(0, 0, 0, 0.7) 0%,
    rgba(0, 0, 0, 0.3) 50%,
    rgba(0, 0, 0, 0.1) 100%
  );
  display: flex;
  align-items: flex-end;
  padding: 80px 160px;

  @media (max-width: 960px) {
    padding: 60px 40px;
  }

  @media (max-width: 768px) {
    padding: 40px 20px;
  }
`;

export const CarouselContent = styled.div`
  max-width: 800px;
  color: white;
  animation: ${fadeIn} 0.8s ease-in-out 0.2s both;
`;

export const CarouselTitle = styled.h1`
  font-size: 3rem;
  font-weight: 700;
  margin: 0 0 16px 0;
  line-height: 1.2;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);

  @media (max-width: 960px) {
    font-size: 2.25rem;
    margin-bottom: 12px;
  }

  @media (max-width: 768px) {
    font-size: 1.75rem;
    margin-bottom: 8px;
  }
`;

export const CarouselSubtitle = styled.p`
  font-size: 1.25rem;
  font-weight: 400;
  margin: 0;
  line-height: 1.5;
  opacity: 0.95;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);

  @media (max-width: 960px) {
    font-size: 1.125rem;
  }

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

export const DotsContainer = styled.div`
  display: flex;
  gap: 12px;
  position: absolute;
  bottom: 32px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;

  @media (max-width: 768px) {
    bottom: 20px;
  }
`;

interface DotProps {
  $active: boolean;
}

export const Dot = styled.button<DotProps>`
  width: ${props => props.$active ? '32px' : '12px'};
  height: 12px;
  border-radius: 6px;
  border: none;
  background-color: ${props => props.$active ? '#fff' : 'rgba(255, 255, 255, 0.5)'};
  cursor: pointer;
  transition: all 0.3s ease;
  padding: 0;

  &:hover {
    background-color: #fff;
    width: 32px;
  }
`;

export const ArrowButton = styled.button`
  border: none;
  width: 56px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.9);
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 10;

  &:hover {
    background-color: #fff;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.25);
    transform: translateY(-50%) scale(1.1);
  }

  &:active {
    transform: translateY(-50%) scale(0.95);
  }

  > img {
    width: 24px;
    height: 24px;
  }

  @media (max-width: 768px) {
    width: 48px;
    height: 48px;

    > img {
      width: 20px;
      height: 20px;
    }
  }
`;
